import {Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {VctCollectedChartData} from '../../../../models/vct-collected-chart-data.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-vct-from',
  templateUrl: './vct-from.component.html',
  styleUrls: ['./vct-from.component.scss']
})
export class VctFromComponent implements OnInit {

  text!: string;
  subtitle = '';
  data!: VctCollectedChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('collected', 'COUNTRY_SCHEMA')
        .subscribe(data => {
          this.years = data;
          this.years.unshift(this.years[0] + 1);
          if (!search.startYear) {
            search.startYear = data[0];
          }
          if (!search.order) {
            search.order = 'alph';
          }
          this.text = 'European collection target (WEEE II), ' + search.startYear;
          this.subtitle = '65% of Average Market input ' + (search.startYear - 3) + ' - ' + (search.startYear - 1) + ' (kg/inhabitant)';
          this.kfChartsService.getVCTFrom(search).subscribe(response => {
            this.data = response;
          });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

}
